import React, { Component } from "react";
import { connect } from "react-redux";
import { fetchSlimCoursesForAdmin } from "../../actions/coursesActions";
import { Table, Input, Button, Row, Col } from "reactstrap";
import CreateCourse from "../../components/Modal/CreateCourse";
import { PacmanLoader } from "react-spinners";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CourseAdminNav from "../../components/Navigation/CourseAdminNav";
import axios from "../../services/api/api";
import { toast } from "react-toastify";
import { FormattedMessage } from "react-intl";
import { API_BASE_URL } from "../../constants/api.constants";
import { TOAST_CONFIG } from "../../Utilities/toastConfig";
import { injectIntl } from "react-intl";
import { PiCheckCircle, PiWarningCircle } from "react-icons/pi";

class CoursesList extends Component {
  state = {
    filterSearch: "",
    isExpanded: false,
    selectedCourse: null,
    modalIsOpen: false,
    deleteModalIsOpen: false,
    updatingCourse: [],
  };

  componentDidMount() {
    this.props.dispatch(fetchSlimCoursesForAdmin());
  }

  updateCourses = () => {
    this.props.dispatch(fetchSlimCoursesForAdmin());
  };

  toggleModal = () => {
    this.setState({ modalIsOpen: !this.state.modalIsOpen });
  };

  toggleExpand = () => {
    this.setState({ isExpanded: !this.state.isExpanded });
  };

  selectCourse = (course, programLicenses) => {
    course.programLicenses = programLicenses;

    this.setState({ selectedCourse: course });
    this.toggleModal();
  };

  deleteCourse = (courseId) => {
    axios
      .delete("/Course/" + courseId)
      .then((response) => {})
      .catch((err) => {
        toast.warn(err.response.data);
      });

    var index = this.props.courses.slimResult.findIndex((course) => {
      return course.id === courseId;
    });

    this.props.courses.slimResult.splice(index, 1);
  };

  setHideStatus = (courseId, hideForStudents, hideForTeachers) => {
    axios
      .post(`${API_BASE_URL}/Course/SetHideStatus/`, {
        id: courseId,
        hideForStudents: hideForStudents,
        hideForTeachers: hideForTeachers,
      })
      .then(() => {
        toast.success("Hide status ändrad", TOAST_CONFIG);
        this.updateCourses();
      })
      .catch((err) => {
        toast.warn(
          err && err.response && err.response.data
            ? err.response.data
            : "Det gick inte att sätta hide status",
          TOAST_CONFIG
        );
      });
  };

  createNew = () => {
    this.setState({ selectedCourse: null });
    this.toggleModal();
  };

  filterSearch = (event) => {
    this.setState({ filterSearch: event.target.value });
  };

  handleToggleCourseAsLoading = (courseId) => {
    if (this.state.updatingCourse.includes(courseId)) {
      this.setState({
        updatingCourse: this.state.updatingCourse.filter(function (course) {
          return course !== courseId;
        }),
      });
      this.updateCourses();
    } else {
      this.setState({
        updatingCourse: [...this.state.updatingCourse, courseId],
      });
    }
  };

  render() {
    if (this.props.courses.error) {
    }

    if (this.props.courses.loading === true) {
      return (
        <div
          className="sweet-loading"
          style={{ position: "fixed", top: "50%", left: "50%" }}
        >
          <PacmanLoader color={"#20a8d8"} loading={true} />
        </div>
      );
    }

    let coursesFilteredByName = null;
    let coursesFilteredByDescription = null;

    var courses = this.props.courses.slimResult;
    if (this.state.filterSearch.length > 0) {
      coursesFilteredByName = courses.filter((it) =>
        (it.course.name ?? "")
          .toLowerCase()
          .includes(this.state.filterSearch.toLowerCase())
      );
      coursesFilteredByDescription = courses.filter((it) =>
        (it.course.description ?? "")
          .toLowerCase()
          .includes(this.state.filterSearch.toLowerCase())
      );
      let tempAllFilteredCourses = [...coursesFilteredByName];
      coursesFilteredByDescription.forEach((fd) => {
        if (
          !tempAllFilteredCourses.some((to) => to.course.id === fd.course.id)
        ) {
          tempAllFilteredCourses.push(fd);
        }
      });
      courses = tempAllFilteredCourses;
    }

    let availableProgramLicenses = [];

    this.props.courses.slimResult.forEach((item) => {
      if (item.programs?.length > 0) {
        item.programs.forEach((prog) => {
          if (
            availableProgramLicenses.filter(
              (x) => x.licenseName === prog.licenseName
            ).length === 0
          ) {
            availableProgramLicenses.push(prog);
          }
        });
      }
    });

    var mappedCourses = courses.map((course, id) => {
      var programs = [];
      if (course.programs?.length > 0) {
        course.programs.forEach((license) => {
          if (programs.indexOf(license.licenseName) === -1)
            programs.push(license.licenseName);
        });
      }
      return (
        <tr key={id}>
          <td>
            <div
              className={
                course.course.imgUrl !== undefined
                  ? "avatar float-start"
                  : "d-none"
              }
              style={{ marginRight: "10px" }}
            >
              <img src={course.course.imgUrl} className="img-avatar" alt="" />
            </div>
          </td>

          <td>
            <Button
              size="sm"
              color="link"
              title={"Klicka för att redigera kurs:" + course.course.name}
              onClick={() => this.selectCourse(course.course, programs)}
              className="text-start w-100"
            >
              {course.course.name}
            </Button>
            {this.state.updatingCourse.includes(course.course.id) ? (
              <p>
                <PacmanLoader color={"#20a8d8"} loading={true} size={10} />
              </p>
            ) : (
              ""
            )}
          </td>
          <td>
            {course.course?.courseModules.filter((cm) => cm.sortOrder === 0)
              .length >= 2 && (
              <PiWarningCircle
                className="warning-icon"
                title={this.props.intl.formatMessage({
                  id: "ModulesNotSorted",
                })}
              />
            )}
          </td>
          <td>
            {course.course.teacherGuideFileUrl != null && (
              <PiCheckCircle className="text-success fs-5" />
            )}
          </td>
          <td className="text-end">{course.course.id}</td>
          <td>{course.course.code}</td>
          <td>{course.course.description}</td>
          <td className="text-end">
            <Button
              size="sm"
              outline
              color="primary"
              title={
                "Klicka för att redigera moudler till kurs:" +
                course.course.name
              }
              onClick={() =>
                this.props.history.push({
                  pathname: "/superuser/courses/coursemodules",
                  state: {
                    courseId: course.course.id,
                    courseName: course.course.name,
                  },
                })
              }
            >
              {course.course.courseModules.length}
            </Button>
          </td>
          <td title={programs.join(", ")} className="text-end">
            <span>{programs.length}</span>
          </td>
          <td align="center">
            <Button
              size="sm"
              outline
              color="blue"
              onClick={() =>
                this.setHideStatus(
                  course.course.id,
                  !course.course.hideCourseForStudents,
                  course.course.hideCourseForTeachers
                )
              }
            >
              <FontAwesomeIcon
                icon="check"
                opacity={course.course.hideCourseForStudents ? 1 : 0}
              />
            </Button>
          </td>
          <td align="center">
            <Button
              size="sm"
              outline
              color="blue"
              onClick={() =>
                this.setHideStatus(
                  course.course.id,
                  course.course.hideCourseForStudents,
                  !course.course.hideCourseForTeachers
                )
              }
            >
              <FontAwesomeIcon
                icon="check"
                opacity={course.course.hideCourseForTeachers ? 1 : 0}
              />
            </Button>
          </td>
          <td>
            <Button
              size="sm"
              outline
              color="danger"
              title={"Radera kurs:" + course.course.name}
              onClick={() => this.deleteCourse(course.course.id)}
            >
              <FontAwesomeIcon icon="trash" />
            </Button>
          </td>
        </tr>
      );
    });

    return (
      <div>
        <CourseAdminNav location="courses" history={this.props.history} />

        <div className="container-fluid admin-container">
          <Row className="mb-2">
            <Col className="col-3">
              <Input
                className="search-input"
                placeholder="Sök kurs"
                onChange={this.filterSearch.bind(this)}
              />
            </Col>
            <Col lg={9}>
              <Button
                size="md"
                outline
                color="primary"
                className="float-end"
                style={{ marginTop: "-10px" }}
                onClick={() => {
                  this.createNew();
                }}
              >
                <FontAwesomeIcon icon="plus" />
                &nbsp;
                <span className="">Ny kurs</span>
              </Button>
            </Col>
          </Row>
          <div style={{ maxHeight: "80vh", overflowY: "auto" }}>
            <Table hover striped className="school-table">
              <thead className="sticky-header">
                <tr>
                  <th />
                  <th>Namn</th>
                  <th></th>
                  <th>
                    <FormattedMessage id="Guide" />
                  </th>
                  <th>
                    <FormattedMessage id="CourseId" />
                  </th>
                  <th>Kod</th>
                  <th>Beskrivning</th>
                  <th>Moduler</th>
                  <th>Programlicenser</th>
                  <th>Dold elever</th>
                  <th>Dold lärare</th>
                  <th>Radera</th>
                </tr>
              </thead>
              <tbody>{mappedCourses}</tbody>
            </Table>
          </div>
        </div>

        <CreateCourse
          isOpen={this.state.modalIsOpen}
          toggle={this.toggleModal}
          toggleExpand={this.toggleExpand}
          isExpanded={this.state.isExpanded}
          updateCourse={this.state.selectedCourse}
          refreshList={this.updateCourses}
          availableProgramLicenses={availableProgramLicenses}
          handleToggleCourseAsLoading={this.handleToggleCourseAsLoading}
        />
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    courses: store.coursesListReducer,
  };
};

export default injectIntl(connect(mapStateToProps)(CoursesList));
